function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "freemium-item_svg__a",
  x1: "108.037%",
  x2: "35.764%",
  y1: "126.994%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#757E95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 30L15.067 0 30 30H8.711l2.711-3.956H23.2L15.067 9.289 4.8 30z",
  fill: "url(#freemium-item_svg__a)",
  fillRule: "nonzero"
});

function SvgFreemiumItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2);
}

export default SvgFreemiumItem;